/* Entonnoir contact : sujet → réponses FAQ → formulaire.
   Le formulaire n'apparaît qu'après « ça ne répond pas à ma question ».
   Anti-spam : honeypot + délai minimal de 3 s avant envoi. */
(() => {
  const tuiles = [...document.querySelectorAll('[data-ct-sujet]')];
  if (!tuiles.length) return;
  const panneaux = [...document.querySelectorAll('[data-ct-reponses]')];
  const form = document.querySelector('[data-ct-form]');
  const champSujet = document.querySelector('[data-ct-champ-sujet]');
  const blocCommande = document.querySelector('[data-ct-champ-commande]');
  const inputCommande = blocCommande && blocCommande.querySelector('input');
  const msgRapide = document.querySelector('[data-ct-rapide]');
  const SUJETS_COMMANDE = ['ou-est-ma-commande', 'probleme-commande', 'retour-echange'];
  const arrivee = Date.now();

  const formIn = document.querySelector('.ct-form-in');
  const champPiege = document.getElementById('ct-site');
  const inputEmail = document.getElementById('ct-email');
  const bouton = formIn && formIn.querySelector('button[type="submit"]');

  /* Photos : envoyées au script Drive du SAV (Apps Script, voir
     scripts/apps-script-sav-photos.gs), qui les range dans un sous-dossier
     nommé d'après le numéro de commande et renvoie l'URL du dossier ; le
     mail la reçoit via le champ caché contact[photos].
     Pourquoi l'envoi part DÈS LA SÉLECTION et pas au clic sur Envoyer
     (diagnostic du 2026-10-18) : la protection anti-spam hCaptcha de Shopify
     écoute aussi le submit et appelle form.submit() elle-même ~300 ms après
     le clic, sans tenir compte d'un preventDefault. Un envoi lancé au clic
     n'a donc jamais le temps de finir : le mail partait avec le champ vide.
     Ici le champ caché est rempli avant toute soumission, et le bouton
     Envoyer reste grisé tant que l'envoi est en cours.
     Garde-fous anti-spam côté site (en plus du jeton, des 2 images de
     10 Mo max et du quota journalier du script) : pas d'envoi si le piège
     à robots est rempli, moins de 3 s après l'arrivée sur la page, sans
     e-mail valide dans le formulaire, ou au-delà de MAX_ENVOIS_PAGE envois
     par chargement de page.
     Compression dans le navigateur (2000 px, JPEG 85 %), lien mémorisé
     (sessionStorage) et remis dans le champ caché si la page revient sans
     être passée par « Bien reçu », un nouvel essai automatique et un délai
     maximal par envoi. */
  const blocPhotos = document.querySelector('[data-ct-photos]');
  const inputPhotos = blocPhotos && blocPhotos.querySelector('input[type="file"]');
  const urlsPhotos = blocPhotos && blocPhotos.querySelector('[data-ct-photos-urls]');
  const erreurPhotos = blocPhotos && blocPhotos.querySelector('[data-ct-photos-erreur]');
  const etatPhotos = blocPhotos && blocPhotos.querySelector('[data-ct-photos-etat]');
  const listePhotos = blocPhotos && blocPhotos.querySelector('[data-ct-photos-liste]');
  const boutonAjouter = blocPhotos && blocPhotos.querySelector('[data-ct-photos-ajouter]');
  const texteAjouter = boutonAjouter && (boutonAjouter.querySelector('[data-ct-photos-ajouter-texte]') || boutonAjouter);
  const libelleAjouter = texteAjouter ? texteAjouter.textContent.trim() : '';
  const texteBouton = bouton && (bouton.querySelector('.btn-txt') || bouton);
  const libelleBouton = texteBouton ? texteBouton.textContent : '';
  const MAX_PHOTOS = 2;
  const MAX_OCTETS_PHOTO = 10 * 1024 * 1024;
  const MAX_ENVOIS_PAGE = 4;
  const DELAI_MIN_ENVOI = 3000;
  const COTE_MAX = 2000;
  const QUALITE_JPEG = 0.85;
  const DELAI_ENVOI = 45000;
  const CLE_MEMO = 'ct-photos';
  const MEMO_MAX_AGE = 60 * 60 * 1000;
  let photosPretes = false;
  let envoiEnCours = false;
  let selectionRefusee = false;
  let nbEnvois = 0;
  let preparation = null;
  /* La sélection fait foi ici, pas dans l'input natif : ajouter une photo
     complète la liste au lieu de la remplacer, retirer en enlève une, et à
     chaque changement l'ensemble visible repart dans un nouveau dossier. */
  let fichiersChoisis = [];

  const memoriser = (valeur) => {
    try {
      if (valeur) sessionStorage.setItem(CLE_MEMO, JSON.stringify({ valeur, t: Date.now() }));
      else sessionStorage.removeItem(CLE_MEMO);
    } catch { /* stockage indisponible : on fait sans */ }
  };

  const lireMemo = () => {
    try {
      const memo = JSON.parse(sessionStorage.getItem(CLE_MEMO) || 'null');
      return memo && Date.now() - memo.t < MEMO_MAX_AGE ? memo.valeur : '';
    } catch { return ''; }
  };

  const afficherErreurPhotos = (texte) => {
    erreurPhotos.textContent = texte;
    erreurPhotos.hidden = !texte;
  };

  const afficherEtatPhotos = (texte) => {
    if (!etatPhotos) return;
    etatPhotos.textContent = texte;
    etatPhotos.hidden = !texte;
  };

  /* Bouton pendant l'envoi : gris + barre fictive (~6 s, en CSS), libellé
     « Envoi des photos... ». À la fin, la barre file à 100 % puis le bouton
     redevient rouge « Envoyer ». Le bouton reste inactif tout du long. */
  let minuteurBouton = null;
  const figerBouton = (texte) => {
    if (!bouton) return;
    clearTimeout(minuteurBouton);
    bouton.disabled = true;
    texteBouton.textContent = texte;
    bouton.classList.remove('ct-fini');
    /* deux rendus successifs : la barre repart bien de zéro */
    bouton.classList.remove('ct-chargement');
    void bouton.offsetWidth;
    bouton.classList.add('ct-chargement');
  };

  const libererBouton = () => {
    if (!bouton) return;
    if (!bouton.classList.contains('ct-chargement')) { bouton.disabled = false; return; }
    bouton.classList.add('ct-fini');
    minuteurBouton = setTimeout(() => {
      bouton.classList.remove('ct-chargement', 'ct-fini');
      texteBouton.textContent = libelleBouton;
      bouton.disabled = false;
    }, 520);
  };

  /* Vignettes des photos choisies, avec un bouton Retirer qui recompose la
     sélection (DataTransfer) et relance la préparation. */
  const extension = (nom) => (String(nom).split('.').pop() || 'img').slice(0, 5);
  const afficherVignettes = () => {
    if (!listePhotos) return;
    listePhotos.textContent = '';
    const fichiers = [...fichiersChoisis];
    listePhotos.hidden = !fichiers.length;
    if (boutonAjouter) {
      boutonAjouter.hidden = fichiers.length >= MAX_PHOTOS;
      texteAjouter.textContent = fichiers.length ? blocPhotos.dataset.ajouterEncore : libelleAjouter;
    }
    fichiers.forEach((fichier, index) => {
      const item = document.createElement('li');
      item.className = 'ct-vignette-item';
      let apercu;
      if (/^image\//.test(fichier.type)) {
        apercu = document.createElement('img');
        apercu.className = 'ct-vignette';
        apercu.alt = '';
        const url = URL.createObjectURL(fichier);
        apercu.onload = () => URL.revokeObjectURL(url);
        apercu.onerror = () => {
          URL.revokeObjectURL(url);
          const generique = document.createElement('div');
          generique.className = 'ct-vignette ct-generique';
          generique.textContent = extension(fichier.name);
          apercu.replaceWith(generique);
        };
        apercu.src = url;
      } else {
        apercu = document.createElement('div');
        apercu.className = 'ct-vignette ct-generique';
        apercu.textContent = extension(fichier.name);
      }
      const nom = document.createElement('span');
      nom.className = 'ct-vignette-nom';
      nom.textContent = fichier.name;
      const retirer = document.createElement('button');
      retirer.type = 'button';
      retirer.className = 'ct-vignette-retirer';
      retirer.setAttribute('aria-label', blocPhotos.dataset.retirer || 'Retirer');
      retirer.textContent = '\u00d7';
      retirer.addEventListener('click', () => {
        if (envoiEnCours) return;
        if (nbEnvois >= MAX_ENVOIS_PAGE) { afficherErreurPhotos(blocPhotos.dataset.limite); return; }
        fichiersChoisis.splice(index, 1);
        appliquerSelection(false);
      });
      item.append(apercu, nom, retirer);
      listePhotos.appendChild(item);
    });
  };

  const marquerVignettes = (classe) => {
    if (!listePhotos) return;
    [...listePhotos.children].forEach((item) => {
      item.classList.remove('envoi', 'ok');
      if (classe) item.classList.add(classe);
    });
  };

  /* Même nettoyage que le script : le nom envoyé est celui du dossier créé. */
  const nettoyer = (texte) => String(texte || '').replace(/[^\w àâäéèêëîïôöùûüç@.#-]/gi, '').trim().slice(0, 60);

  const nomDossier = () => {
    const commande = inputCommande && !inputCommande.disabled ? nettoyer(inputCommande.value) : '';
    if (commande) return commande;
    /* à la seconde : chaque renvoi a son dossier, le lien du mail montre
       exactement la sélection finale */
    const d = new Date();
    const deux = (n) => String(n).padStart(2, '0');
    return `sans-commande-${d.getFullYear()}-${deux(d.getMonth() + 1)}-${deux(d.getDate())}-${deux(d.getHours())}${deux(d.getMinutes())}${deux(d.getSeconds())}`;
  };

  const chargerImage = (fichier) => new Promise((resoudre, rejeter) => {
    const url = URL.createObjectURL(fichier);
    const img = new Image();
    img.onload = () => { URL.revokeObjectURL(url); resoudre(img); };
    img.onerror = () => { URL.revokeObjectURL(url); rejeter(new Error('image illisible')); };
    img.src = url;
  });

  /* Réduit une photo au plus grand côté COTE_MAX en JPEG. Si le navigateur
     ne sait pas la lire (format exotique) ou si ça ne gagne rien, on garde
     l'original. */
  const compresser = async (fichier) => {
    if (!/^image\//.test(fichier.type)) return fichier;
    try {
      const img = await chargerImage(fichier);
      const ratio = Math.min(1, COTE_MAX / Math.max(img.naturalWidth, img.naturalHeight));
      if (ratio === 1 && fichier.size < 1024 * 1024) return fichier;
      const canvas = document.createElement('canvas');
      canvas.width = Math.round(img.naturalWidth * ratio);
      canvas.height = Math.round(img.naturalHeight * ratio);
      canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
      const blob = await new Promise((resoudre) => canvas.toBlob(resoudre, 'image/jpeg', QUALITE_JPEG));
      if (!blob || blob.size >= fichier.size) return fichier;
      const nom = fichier.name.replace(/\.[^.]+$/, '') + '.jpg';
      return new File([blob], nom, { type: 'image/jpeg' });
    } catch {
      return fichier;
    }
  };

  /* Compression puis contrôle du nombre et du poids. Renvoie la liste prête
     à partir, ou null si la sélection est refusée. */
  const preparerPhotos = async () => {
    const fichiers = [...fichiersChoisis];
    if (!fichiers.length) return [];
    if (fichiers.length > MAX_PHOTOS) return null;
    const prets = [];
    for (const fichier of fichiers) prets.push(await compresser(fichier));
    return prets.every((f) => f.size <= MAX_OCTETS_PHOTO) ? prets : null;
  };

  const enBase64 = (fichier) => new Promise((resoudre, rejeter) => {
    const lecteur = new FileReader();
    lecteur.onload = () => resoudre(String(lecteur.result).split(',')[1]);
    lecteur.onerror = rejeter;
    lecteur.readAsDataURL(fichier);
  });

  const envoyerAuScript = async (corps) => {
    const controleur = new AbortController();
    const minuteur = setTimeout(() => controleur.abort(), DELAI_ENVOI);
    try {
      /* Corps en texte brut (pas de préflight CORS) ; le script répond en JSON. */
      const reponse = await fetch(blocPhotos.dataset.url, { method: 'POST', body: corps, signal: controleur.signal });
      if (!reponse.ok) throw new Error('upload photos');
      const resultat = await reponse.json();
      if (!resultat.url) throw new Error(resultat.erreur || 'upload photos');
      return resultat.url;
    } finally {
      clearTimeout(minuteur);
    }
  };

  const uploaderPhotos = async (prets, dossier) => {
    const fichiers = [];
    for (const fichier of prets) {
      fichiers.push({ nom: fichier.name, type: fichier.type, donnees: await enBase64(fichier) });
    }
    const corps = JSON.stringify({ jeton: blocPhotos.dataset.jeton, dossier, fichiers });
    let url;
    try {
      url = await envoyerAuScript(corps);
    } catch {
      url = await envoyerAuScript(corps);
    }
    urlsPhotos.value = url;
    memoriser(url);
    photosPretes = true;
  };

  /* Un envoi ne part que si tout est réuni : des photos acceptées, pas
     d'envoi déjà fait ou en cours, piège à robots vide, plus de 3 s sur la
     page, un e-mail valide, et le plafond par page non atteint. Sinon on
     attend la prochaine saisie (événement input) ou le clic sur Envoyer. */
  const conditionsEnvoi = () => {
    if (!fichiersChoisis.length) return false;
    if (photosPretes || envoiEnCours || selectionRefusee) return false;
    if (champPiege && champPiege.value) return false;
    if (Date.now() - arrivee < DELAI_MIN_ENVOI) return false;
    if (!inputEmail || !inputEmail.value || !inputEmail.checkValidity()) return false;
    if (nbEnvois >= MAX_ENVOIS_PAGE) return false;
    return true;
  };

  const envoyerPhotos = async () => {
    if (!conditionsEnvoi()) return;
    envoiEnCours = true;
    nbEnvois += 1;
    figerBouton(blocPhotos.dataset.envoi);
    afficherEtatPhotos('');
    marquerVignettes('envoi');
    const dossier = nomDossier();
    try {
      const prets = await (preparation || preparerPhotos());
      if (prets === null) {
        selectionRefusee = true;
        afficherErreurPhotos(blocPhotos.dataset.trop);
        marquerVignettes('');
        return;
      }
      await uploaderPhotos(prets, dossier);
      afficherErreurPhotos('');
      afficherEtatPhotos(blocPhotos.dataset.ok);
      marquerVignettes('ok');
    } catch {
      marquerVignettes('');
      /* Le mail dira que le client a essayé et où regarder : le script a pu
         enregistrer les photos même si la réponse n'est pas arrivée. */
      const note = blocPhotos.dataset.echec.replace('{nom}', dossier);
      urlsPhotos.value = note;
      memoriser(note);
      afficherErreurPhotos(blocPhotos.dataset.erreur);
    } finally {
      envoiEnCours = false;
      libererBouton();
    }
  };

  /* Nouvelle sélection (ajout ou retrait) : tout repart de zéro pour cet
     ensemble, lien compris, puis l'envoi part si les conditions sont là. */
  const appliquerSelection = (tropNombreuses) => {
    /* Plafond d'envois atteint : on ne touche plus à la sélection ni au
       lien déjà obtenu, on l'explique. */
    if (nbEnvois >= MAX_ENVOIS_PAGE) {
      afficherErreurPhotos(blocPhotos.dataset.limite);
      return false;
    }
    photosPretes = false;
    selectionRefusee = false;
    urlsPhotos.value = '';
    memoriser('');
    afficherErreurPhotos(tropNombreuses ? blocPhotos.dataset.trop : '');
    afficherEtatPhotos('');
    afficherVignettes();
    if (!fichiersChoisis.length) { preparation = null; return; }
    preparation = preparerPhotos();
    preparation.then((prets) => {
      if (prets === null) {
        selectionRefusee = true;
        afficherErreurPhotos(blocPhotos.dataset.trop);
      } else {
        envoyerPhotos();
      }
    });
    return true;
  };

  if (inputPhotos) {
    inputPhotos.addEventListener('change', () => {
      if (envoiEnCours) { inputPhotos.value = ''; return; }
      const nouveaux = [...inputPhotos.files];
      inputPhotos.value = '';
      if (!nouveaux.length) return;
      if (nbEnvois >= MAX_ENVOIS_PAGE) { afficherErreurPhotos(blocPhotos.dataset.limite); return; }
      let ignorees = 0;
      nouveaux.forEach((f) => {
        if (fichiersChoisis.length < MAX_PHOTOS) fichiersChoisis.push(f);
        else ignorees += 1;
      });
      /* rien n'a pu être ajouté : on le dit, sans toucher à ce qui est là */
      if (ignorees === nouveaux.length) { afficherErreurPhotos(blocPhotos.dataset.trop); return; }
      appliquerSelection(ignorees > 0);
    });

    /* Photos choisies avant l'e-mail : l'envoi part dès que l'e-mail est
       saisi. */
    if (formIn) formIn.addEventListener('input', () => { envoyerPhotos(); });

    /* Clic sur Envoyer alors que les photos ne sont pas encore parties
       (cas rare : e-mail rempli par autocomplétion, moins de 3 s sur la
       page). On bloque le clic lui-même, avant tout événement submit, donc
       avant le script hCaptcha de Shopify ; l'envoi fait, requestSubmit()
       relance la soumission normale, hCaptcha compris. */
    if (bouton) {
      bouton.addEventListener('click', (e) => {
        if (!fichiersChoisis.length || photosPretes || urlsPhotos.value) return;
        if (selectionRefusee) {
          e.preventDefault();
          afficherErreurPhotos(blocPhotos.dataset.trop);
          return;
        }
        if (!conditionsEnvoi()) return;
        e.preventDefault();
        envoyerPhotos().then(() => {
          if (!photosPretes && !urlsPhotos.value) return;
          if (typeof formIn.requestSubmit === 'function') formIn.requestSubmit();
          else formIn.submit();
        });
      }, true);
    }
  }

  const stamperSujet = (cle) => {
    const params = new URLSearchParams(window.location.search);
    params.set('sujet', cle);
    history.replaceState(null, '', `${window.location.pathname}?${params.toString()}${window.location.hash}`);
  };

  const choisir = (cle, ouvrirForm) => {
    tuiles.forEach((t) => t.classList.toggle('on', t.dataset.ctSujet === cle));
    panneaux.forEach((p) => { p.hidden = p.dataset.ctReponses !== cle; });
    if (champSujet) {
      const tuile = tuiles.find((t) => t.dataset.ctSujet === cle);
      champSujet.value = tuile ? tuile.textContent.trim() : cle;
    }
    if (blocCommande) {
      const avecCommande = SUJETS_COMMANDE.includes(cle);
      blocCommande.hidden = !avecCommande;
      if (inputCommande) {
        inputCommande.disabled = !avecCommande;
        inputCommande.required = avecCommande;
      }
    }
    if (form && !form.querySelector('.ct-merci')) form.hidden = !ouvrirForm;
  };

  tuiles.forEach((t) => t.addEventListener('click', () => {
    choisir(t.dataset.ctSujet, false);
    stamperSujet(t.dataset.ctSujet);
  }));
  document.querySelectorAll('[data-ct-ouvrir]').forEach((b) => b.addEventListener('click', () => {
    const actif = tuiles.find((t) => t.classList.contains('on'));
    choisir(actif ? actif.dataset.ctSujet : 'autre', true);
    form.querySelector('input:not([type="hidden"]):not(#ct-site)')?.focus();
  }));

  if (formIn && !formIn.querySelector('.ct-merci')) {
    formIn.addEventListener('submit', (e) => {
      if ((champPiege && champPiege.value) || Date.now() - arrivee < DELAI_MIN_ENVOI) {
        e.preventDefault();
        if (msgRapide) msgRapide.hidden = false;
        return;
      }
      /* Le formulaire s'estompe pendant que la soumission suit son cours,
         pas de coupure brute. Les photos, elles, sont déjà parties. */
      formIn.classList.add('ct-envoi');
    });
  }

  /* État initial : on restaure d'abord le sujet depuis l'URL (tuile active,
     réponses affichées, état required/disabled du champ numéro de commande),
     puis on force le formulaire visible si la page revient d'un POST — succès
     (bloc merci) ou erreurs serveur (bloc erreurs). Sans ces deux marqueurs,
     ?sujet= seul ouvre juste l'étape 2, sans afficher le formulaire. */
  const param = new URLSearchParams(window.location.search).get('sujet');
  if (param && tuiles.some((t) => t.dataset.ctSujet === param)) choisir(param, false);

  if (form && (form.querySelector('.ct-merci') || form.querySelector('.ct-erreurs'))) {
    form.hidden = false;
  }

  /* Lien mémorisé : « Bien reçu » l'efface ; sinon (retour depuis la page
     anti-robot, rechargement), on le remet dans le champ caché pour que le
     mail parte avec, même si la photo n'est plus dans le champ fichier. */
  if (form && form.querySelector('.ct-merci')) {
    memoriser('');
  } else if (urlsPhotos && !urlsPhotos.value) {
    const memo = lireMemo();
    if (memo) {
      urlsPhotos.value = memo;
      if (memo.startsWith('http')) photosPretes = true;
    }
  }
})();
